import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "source",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = ["readonly"]
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "fromCurrency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = {
  for: "toCurrency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_15 = { class: "col-sm-8" }
const _hoisted_16 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_17 = {
  for: "rate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_18 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.source")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`source`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  readonly: !!_ctx.form.id,
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.source) = $event)),
                  "data-maska": "A",
                  "data-maska-tokens": "A:[0-9a-zA-Z_]:multiple",
                  type: "text",
                  id: "source"
                }, null, 10, _hoisted_6), [
                  [_vModelText, _ctx.form.source],
                  [_directive_maska]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans("labels.title")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.from_currency")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Multiselect, {
              id: "fromCurrency",
              class: "",
              modelValue: _ctx.form.fromCurrency,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.fromCurrency) = $event)),
              options: _ctx.currencies,
              "custom-label": (opt) => `${opt}`,
              multiple: false,
              "select-label": "Select",
              placeholder: ""
            }, null, 8, ["modelValue", "options", "custom-label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans("labels.to_currency")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Multiselect, {
              id: "toCurrency",
              class: "",
              modelValue: _ctx.form.toCurrency,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.toCurrency) = $event)),
              options: _ctx.currencies,
              "custom-label": (opt) => `${opt}`,
              multiple: false,
              "select-label": "Select",
              placeholder: ""
            }, null, 8, ["modelValue", "options", "custom-label"])
          ])
        ]),
        (_ctx.canSetRateValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.helper.trans("labels.rate")), 1),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`rate`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.rate) = $event)),
                      type: "text",
                      id: "rate"
                    }, null, 2), [
                      [_vModelText, _ctx.form.rate]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}